export const MASTERCLASS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_desktop_image: "",
    meta_mobile_image: "",
    meta_name: "",
    meta_name_text_color: "#000000",
    meta_designation: "",
    meta_designation_text_color: "#666666",
    meta_description: "",
    meta_description_text_color: "#666666",
    meta_description_background_color: "#ffffff",
    meta_icon1: "",
    meta_icon2: "",
    meta_info_1_label: "Date",
    meta_info_1_value: "",
    meta_info_2_label: "Time",
    meta_info_2_value: "",
    meta_info_label_color: "#cf6384",
    meta_info_value_color: "#f8f9fa",
    meta_info_divider_color: "rgba(255,255,255,0.3)",
    meta_alt_image: "",
    meta_priority: 0,
    meta_status: false,
  },

  MASTERCLASS_FIELDS_CONFIG: [
    {
      fieldName: "layout_variant",
      label: "Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (Default)", value: "variant_1" },
        { label: "Variant 2 (Poppins / date-time)", value: "variant_2" },
      ],
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Left Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Left Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left navigation icon",
      required: false,
      defaultValue: "Left navigation",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Right Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Right Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right navigation icon",
      required: false,
      defaultValue: "Right navigation",
    },
    {
      fieldName: "show_button",
      label: "Show Button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Toggle CTA button visibility",
      defaultValue: true,
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text (e.g., View All)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "button_background_color",
      label: "Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button background color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_icon",
      label: "Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "Button Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button icon",
      required: false,
      defaultValue: "Button icon",
    },
    {
      fieldName: "button_hover_icon",
      label: "Button Hover Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Hover Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_hover_icon_alt",
      label: "Button Hover Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button hover icon",
      required: false,
      defaultValue: "Button hover icon",
    },
    {
      fieldName: "show_quote_icon",
      label: "Show Quote Icon",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Toggle quote icon visibility",
      defaultValue: true,
    },
    {
      fieldName: "quote_icon",
      label: "Quote Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Quote Icon (optional, overrides default)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "quote_icon_alt",
      label: "Quote Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for quote icon",
      required: false,
      defaultValue: "Quote icon",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
      defaultValue: false,
    }
  ],

  METADATA_FIELDS: [
    {
      header: "Desktop Image",
      fieldName: "meta_desktop_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Image",
    },
    {
      header: "Mobile Image",
      fieldName: "meta_mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Image",
    },
    {
      header: "Name",
      fieldName: "meta_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Name",
    },
    {
      header: "Name Text Color",
      fieldName: "meta_name_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter name text color (e.g., #000000)",
    },
    {
      header: "Designation",
      fieldName: "meta_designation",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Designation",
    },
    {
      header: "Designation Text Color",
      fieldName: "meta_designation_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter designation text color (e.g., #666666)",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
    },
    {
      header: "Description Text Color",
      fieldName: "meta_description_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description text color (e.g., #666666)",
    },
    {
      header: "Description Card Background Color",
      fieldName: "meta_description_background_color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description background color (e.g., #ffffff)",
    },
    {
      header: "Icon 1",
      fieldName: "meta_icon1",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon 1",
    },
    {
      header: "Icon 1 Alt Text",
      fieldName: "meta_icon1_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Text for Icon 1",
    },
    {
      header: "Icon 2",
      fieldName: "meta_icon2",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon 2",
    },
    {
      header: "Icon 2 Alt Text",
      fieldName: "meta_icon2_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Text for Icon 2",
    },
    {
      header: "Info 1 Label (Variant 2)",
      fieldName: "meta_info_1_label",
      value: "Date",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Date",
    },
    {
      header: "Info 1 Value (Variant 2)",
      fieldName: "meta_info_1_value",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 19th June'26",
    },
    {
      header: "Info 2 Label (Variant 2)",
      fieldName: "meta_info_2_label",
      value: "Time",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Time",
    },
    {
      header: "Info 2 Value (Variant 2)",
      fieldName: "meta_info_2_value",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 07:30 PM",
    },
    {
      header: "Info Label Color (Variant 2)",
      fieldName: "meta_info_label_color",
      value: "#cf6384",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #cf6384",
    },
    {
      header: "Info Value Color (Variant 2)",
      fieldName: "meta_info_value_color",
      value: "#f8f9fa",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #f8f9fa",
    },
    {
      header: "Info Divider Color (Variant 2)",
      fieldName: "meta_info_divider_color",
      value: "rgba(255,255,255,0.3)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. rgba(255,255,255,0.3)",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ]
};

